module.exports = __webpack_public_path__ + "img/video.faa92445.svg";